<app-header *ngIf="logintype=='User' || !logintype"></app-header>
<!-- <app-labheader *ngIf="logintype=='Labs'"></app-labheader>
<app-pharmacyheader *ngIf="logintype=='Pharmecy'"></app-pharmacyheader>
<app-hospital-header *ngIf="logintype=='Hospital'"></app-hospital-header>
<app-doctor-header *ngIf="logintype=='Doctor'"></app-doctor-header> -->

<section class="hero-section">
  <div class="container">
    <div class="hero-sect-cnt">
      <h1> Personalized Healthcare Platform to access range of <span> Healthcare </span> Services! </h1>
      <ul class="hero-list clearfix">
        <li>
          <a [routerLink]="['/doctors/list']">
            <div class="hero-list-box">
              <div class="hero-list-box-img">
                <img src="assets/images/doctor-stethoscope.png" alt="image">
              </div>
              <div class="hero-list-cnt">
                <h4> {{ homePageData.listDoctors?.doctorsCount }}+ </h4>
                <h5> Doctors </h5>
              </div>
            </div>
          </a>
        </li>
        <li>
          <a [routerLink]="['/hospitals/list']">
            <div class="hero-list-box">
              <div class="hero-list-box-img">
                <img src="assets/images/medical-kit.png" alt="image">
              </div>
              <div class="hero-list-cnt">
                <h4> {{ homePageData.listHospitals?.hospitalCount }}+ </h4>
                <h5> Hospitals </h5>
              </div>
            </div>
          </a>
        </li>
        <li>
          <a [routerLink]="['/pharmacy/list']">
            <div class="hero-list-box">
              <div class="hero-list-box-img">
                <img src="assets/images/pills.png" alt="image">
              </div>
              <div class="hero-list-cnt">
                <h4> {{ homePageData.listPharmecy?.pharmecyCount }}+ </h4>
                <h5> Pharmacies </h5>
              </div>
            </div>
          </a>
        </li>
        <li>
          <a [routerLink]="['/labs/list']">
            <div class="hero-list-box">
              <div class="hero-list-box-img">
                <img src="assets/images/lab-microscope.png" alt="image">
              </div>
              <div class="hero-list-cnt">
                <h4> {{ homePageData.listLabs?.labCount }}+ </h4>
                <h5> Labs </h5>
              </div>
            </div>
          </a>
        </li>
      </ul>

      <div class="hero-serach">
        <form>
          <div class="form-group-main">
            <div class="row no-gutters">
              <div class="col-md-6">
                <div class="form-group-main-input">
                  <select (change)="gotoDoctorList()" [(ngModel)]="advancedCity" name="advancedCity"
                    class="form-control">
                    <option selected value=''>Choose City...</option>
                    <option [hidden]="city==''" [value]="city" *ngFor="let city of cities">{{ city }}</option>
                    <!-- <option> Mohali </option>
                    <option> Chandigarh </option>
                    <option> Mohali </option> -->
                  </select>
                  <i class="fa fa-map-marker" aria-hidden="true"></i>
                </div>
              </div>
              <!-- <div class="col-md-6">
                  <div class="form-group-main-input">
                      <input type="text" class="form-control" placeholder="Search doctors, hospitals etc.">
                      <i class="fa fa-search" aria-hidden="true"></i>
                  </div>
              </div> -->
            </div>
          </div>

          <div (click)="gotoDoctorList()" class="home-form-filter" id="sort-resutls-btn-1">
            <img src="assets/images/filter-icon.png" alt="filter">
            <span> Advance Search </span>
          </div>

        </form>

      </div>
    </div>

    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
      style="margin-top: 90px;margin-bottom: -20px !important;">
      <div *ngFor="let banner of banners" ngxSlickItem class="slider">
        <a href="javascript://" class="card-box" (click)="gotoDetail(banner)">
          <img [src]="banner.image" alt="first slide" style="display: block; width: 100%;height: 200px;">
        </a>
      </div>
    </ngx-slick-carousel>

  </div>
  <div class="hero-section-main-img">
    <img src="assets/images/home-slider-img.png" alt="image">
    <!-- <img src="assets/images/homepage.gif" alt="image"> -->
  </div>
  <a href="https://api.whatsapp.com/send?phone={{contactNo?.country_code}}{{contactNo?.whats_app_number}}&amp;text=Hello, Team DaktarZ."
    target="_blank">
    <img class="whats_app" src="/assets/images/whatsapp.png">
  </a>

  <a style="position: fixed;bottom: 40px;left: 25px;z-index:9999" [routerLink]="['/blood/list']">
    <img src="/assets/images/blood-clipart.png" style="width: 80px;">
  </a>

  <!-- <div class="hero-section-emergency-btn"> -->
  <div style="z-index:9999" class="emergency-fixed-btn">
    <a [routerLink]="null" class="emergency-btn" (click)="getCurrentLocation()" id="loginEmergency"> <img
        src="assets/images/ambulance.png" alt="icon"><span> Emergency </span></a>
  </div>
  <!-- <a  routerLink="" data-toggle="modal" id="loginEmergency" data-target= "#emergency-book"> <img src="assets/images/emergency-btn.png" alt="image"> </a> -->
  <!-- <a  routerLink="" data-toggle="modal" id="withoutLoginEmergency" data-target= "#emergency-book"> <img src="assets/images/emergency-btn.png" alt="image"> </a> -->
  <!-- </div> -->
</section>
<!--- End of hero-section -->

<section class="home-about-us padd-row" style="padding-bottom: 40px">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="home-abt-img">
          <img src="assets/images/home-abt-left-img.jpg" alt="image">
        </div>
      </div>
      <div class="col-md-6">
        <div class="home-abt-cnt">
          <div class="main-heading">
            <h2> System to provide Quality Healthcare Services with Transparency </h2>
          </div>
          <div class="home-abt-para">
            <ul>
              <li><img src="assets/images/check.png" alt="icon"> Ambulance services in Medical Emergency for critically
                ill and accident victims.
              </li>
              <li><img src="assets/images/check.png" alt="icon"> Book Appointment and chat with Doctors verified by
                DaktarZ.
              </li>
              <li><img src="assets/images/check.png" alt="icon"> Maintains EMRs securely over DaktarZ Platform</li>
              <li><img src="assets/images/check.png" alt="icon"> Live Medicine Order Tracking + Exclusive Health Checkup
                packages and Tests done from Accredited Diagnostic Test Labs
              </li>
            </ul>
          </div>
          <div class="main-btn">
            <a [routerLink]="null" data-toggle="modal" data-target="#medicalTourismPopup" (click)="openTourism()"
              class="btn-style flash-button"> Apply For Medical
              Tourism </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--- End of home-about-us -->

<section class="home-facilities">
  <div class="main-heading text-center">
    <div class="container">

      <h1 class="mt-2" style="text-align: left;"> Consult doctors across different specialities </h1>

      <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfigSpe">
        <div *ngFor="let data of allSpecialities" ngxSlickItem class="slider" (click)="goToDoctorListData(data)">
          <a href="javascript://" class="card-box text-center" style="text-decoration: none;">
            <img [src]="data?.image_url" alt="first slide" style="height: 150px;width: 150px;margin: 0 auto;">
            <a class="w-100" style="display: block;font-size: 24px;text-decoration: none;">{{data?.name}}</a>
          </a>
        </div>
      </ngx-slick-carousel>

      <h2 class="mt-3"> Medical facilities </h2>
    </div>
  </div>
  <div class="home-facilities-main">
    <div class="home-facilities-nav">
      <div class="container">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item"><a class="nav-link active" id="home-facilites-1-tab" (click)="tabChanged()"
              data-toggle="tab" href="#home-facilites-1" role="tab" aria-controls="home-facilites-1"
              aria-selected="true"> Doctors </a></li>
          <li class="nav-item"><a class="nav-link" id="home-facilites-2-tab" (click)="tabChanged()" data-toggle="tab"
              href="#home-facilites-2" role="tab" aria-controls="home-facilites-2" aria-selected="false"> Hospitals </a>
          </li>
          <li class="nav-item"><a class="nav-link" id="home-facilites-3-tab" (click)="tabChanged()" data-toggle="tab"
              href="#home-facilites-3" role="tab" aria-controls="home-facilites-3" aria-selected="false"> Labs </a></li>
          <li class="nav-item"><a class="nav-link" id="home-facilites-4-tab" (click)="tabChanged()" data-toggle="tab"
              href="#home-facilites-4" role="tab" aria-controls="home-facilites-4" aria-selected="false"> Pharmacies
            </a></li>
        </ul>
      </div>
    </div>


    <div class="home-facilites-tabs padd-row">
      <div class="container">
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="home-facilites-1" role="tabpanel"
            aria-labelledby="home-facilites-1-tab">
            <div class="home-facilites-slider-main">
              <ngx-slick-carousel *ngIf="flag2" class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                <div *ngFor="let doctor of homePageData.listDoctors?.listDoctors" ngxSlickItem class="slide">
                  <div class="facilites-box">
                    <div class="facilites-box-img">
                      <img [src]="doctor.profilePicture" alt="image">
                    </div>
                    <div class="facilites-box-cnt">
                      <div class="doc-position"> {{ doctor?.speciality?.slice(0, 12).join(' | ') }}</div>
                      <h4> {{ doctor?.name.slice(0,20) }}{{ doctor?.name.length > 20 ? '...' : '' }}</h4>
                      <div style="cursor:pointer" class="doc-degree">
                        <read-more [text]="doctor?.education?.join(' , ')" [maxLength]="30" [showToggleButton]="true">
                        </read-more>
                      </div>
                      <div class="doc-rating">
                        <div *ngIf="doctor.averageRatings==0 || doctor.averageRatings>0" class="doc-rating-icons">
                          <i *ngFor='let in of counter( parseInt(doctor.averageRatings)) ;let i = index'
                            class="fa fa-star" aria-hidden="true"></i>
                          <i class="fa fa-star-o"
                            *ngFor='let in of counter(5- parseInt(doctor.averageRatings)) ;let i = index'
                            aria-hidden="true"></i>


                        </div>
                        <div *ngIf="doctor.averageRatings==null" class="doc-rating-icons">

                          <i class="fa fa-star-o" *ngFor='let in of counter(5) ;let i = index' aria-hidden="true"></i>


                        </div>
                        <span> {{ !doctor?.averageRatings ? 0 : doctor?.averageRatings }} | {{ doctor?.review?.length }}
                          Reviews </span>
                      </div>
                      <div class="doc-adres">
                        <p><i class="fa fa-map-marker" aria-hidden="true"></i> {{ doctor?.address?.slice(0, 30) }}
                          {{ doctor.address.length > 30 ? '...' : '' }}
                        </p>
                        <!-- <p><i class="fa fa-calendar-check-o" aria-hidden="true"></i> Mon, Tue, Wed, Thu </p> -->
                      </div>
                      <div class="doc-btn-main">
                        <a [routerLink]="['/doctors/detail/'+doctor?.uniquekey]" class="btn-style btn-style-border">
                          Book
                          Now </a>
                      </div>
                    </div>
                  </div>
                </div>


              </ngx-slick-carousel>
              <!-- </ul> -->
              <!-- </owl-carousel-o> -->
              <div class="home-facilites-btm-btn text-right">
                <a [routerLink]="['/doctors/list']" class="btn-arrow"> View All <i class="fa fa-long-arrow-right"
                    aria-hidden="true"></i> </a>
              </div>
            </div>
          </div>


          <div class="tab-pane fade show" id="home-facilites-2" role="tabpanel" aria-labelledby="home-facilites-2-tab">
            <div class="home-facilites-slider-main">
              <ngx-slick-carousel *ngIf="flag2" class="carousel" #slickModal1="slick-carousel" [config]="slideConfig">
                <div *ngFor="let hospital of homePageData.listHospitals?.listAllData" ngxSlickItem class="slide">
                  <div class="facilites-box">
                    <div class="hospital-box-img">
                      <img [src]="hospital.coverPhoto" alt="image">
                      <div class="offer-sticker" *ngIf="hospital.discount>0"> {{ hospital.discount }}% off</div>
                    </div>
                    <div class="facilites-box-cnt">
                      <!-- <div class="doc-position"> Neurosurgeon</div> -->
                      <h4> {{ hospital?.name.slice(0,20) }}{{ hospital?.name.length > 20 ? '...' : '' }} </h4>
                      <!-- <div class="doc-degree"> MBBS, MCPS, MSc (Immunology)</div> -->
                      <div class="doc-rating">
                        <div *ngIf="hospital.averageRatings" class="doc-rating-icons">
                          <i *ngFor='let in of counter( parseInt(hospital.averageRatings)) ;let i = index'
                            class="fa fa-star" aria-hidden="true"></i>
                          <i class="fa fa-star-o"
                            *ngFor='let in of counter(5- parseInt(hospital.averageRatings)) ;let i = index'
                            aria-hidden="true"></i>
                        </div>
                        <div *ngIf="hospital.averageRatings==null || hospital.averageRatings==0"
                          class="doc-rating-icons">

                          <i class="fa fa-star-o" *ngFor='let in of counter(5) ;let i = index' aria-hidden="true"></i>


                        </div>
                        <span> {{ !hospital.averageRatings ? 0 : parseInt(hospital.averageRatings) }} |
                          {{ hospital.review.length }} Reviews </span>
                        <p class="hos-box-bmt-info">
                          <span> {{ hospital.distance / 1000 | number:'1.0-0' }} km Away
                            {{ hospital.doctorsCount>0 ? '| ' +hospital.doctorsCount+'+ Doctors' : '' }} </span>
                          <span class="hos-box-cnt-box-info-imgs">

                            <img alt="image" *ngFor="let image of hospital.docProfilePic" [src]="image">
                            <!-- <img alt="image" src="assets/images/twenty-plus-img.jpg"> -->
                          </span>
                        </p>
                      </div>
                      <div class="doc-adres">
                        <p><i class="fa fa-map-marker" aria-hidden="true"></i> {{ hospital.address.slice(0, 30) }}
                          {{ hospital.address.length > 30 ? '...' : '' }}
                        </p>
                        <!-- <p><i class="fa fa-calendar-check-o" aria-hidden="true"></i> Mon, Tue, Wed, Thu </p> -->
                      </div>
                      <div class="doc-btn-main">
                        <a [routerLink]="['/hospitals/detail/'+hospital._id]" class="btn-style btn-style-border"> Book
                          Now </a>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- </ul> -->
              </ngx-slick-carousel>
              <div class="home-facilites-btm-btn text-right">
                <a [routerLink]="['/hospitals/list']" class="btn-arrow"> View All <i class="fa fa-long-arrow-right"
                    aria-hidden="true"></i> </a>
              </div>
            </div>
          </div>
          <div class="tab-pane show fade" id="home-facilites-3" role="tabpanel" aria-labelledby="home-facilites-3-tab">
            <div class="home-facilites-slider-main">
              <ngx-slick-carousel *ngIf="flag2" class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                <div *ngFor="let lab of homePageData.listLabs?.listAllData" ngxSlickItem class="slider">
                  <div class="facilites-box">
                    <div class="facilites-box-img">
                      <img [src]="lab.profilePicture" alt="image">
                    </div>
                    <div class="facilites-box-cnt">
                      <!-- <div class="doc-position"> Neurosurgeon</div> -->
                      <h4> {{ lab?.name.slice(0,20) }}{{ lab?.name.length > 20 ? '...' : '' }} </h4>
                      <!-- <div class="doc-degree"> MBBS, MCPS, MSc (Immunology)</div> -->
                      <div class="doc-rating">
                        <div *ngIf="lab.rating" class="doc-rating-icons">
                          <i *ngFor='let in of counter( lab.rating) ;let i = index' class="fa fa-star"
                            aria-hidden="true"></i>
                          <i class="fa fa-star-o" *ngFor='let in of counter(5- lab.rating) ;let i = index'
                            aria-hidden="true"></i>
                        </div>
                        <div *ngIf="lab.rating==null || lab.rating==0" class="doc-rating-icons">

                          <i class="fa fa-star-o" *ngFor='let in of counter(5) ;let i = index' aria-hidden="true"></i>


                        </div>
                        <span> {{ !lab.rating ? 0 : lab.rating }} | {{ lab.review.length }} Reviews </span>
                      </div>
                      <div class="hos-box-btm-cnt">
                        <p class="hos-box-bmt-info">
                          <span> Registered Lab <img style="width:25px;height:25px;display:inline;"
                              src="assets/images/bluetick.png"> | {{ lab.testCount }}+ Health Tests </span>
                        </p>
                      </div>

                      <div class="doc-adres">
                        <p><i class="fa fa-map-marker" aria-hidden="true"></i> {{ lab.address.slice(0, 30) }}
                          {{ lab.address.length > 30 ? '...' : '' }}
                        </p>
                        <!-- <p><i class="fa fa-calendar-check-o" aria-hidden="true"></i> Mon, Tue, Wed, Thu </p> -->
                      </div>
                      <div class="doc-btn-main">
                        <a [routerLink]="['/labs/detail/'+lab._id]" class="btn-style btn-style-border"> Book Now </a>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- </ul> -->
              </ngx-slick-carousel>
              <div class="home-facilites-btm-btn text-right">
                <a [routerLink]="['/labs/list']" class="btn-arrow"> View All <i class="fa fa-long-arrow-right"
                    aria-hidden="true"></i> </a>
              </div>
            </div>
          </div>
          <div class="tab-pane show fade" id="home-facilites-4" role="tabpanel" aria-labelledby="home-facilites-4-tab">
            <div class="home-facilites-slider-main">
              <ngx-slick-carousel *ngIf="flag2" class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                <div *ngFor="let pharmacy of homePageData.listPharmecy?.listAllData" ngxSlickItem class="slider">
                  <div class="facilites-box">
                    <div class="facilites-box-img">
                      <img [src]="pharmacy.profilePicture" alt="image">
                    </div>
                    <div class="facilites-box-cnt">
                      <!-- <div class="doc-position"> Neurosurgeon</div> -->
                      <h4> {{ pharmacy?.name.slice(0,20) }}{{ pharmacy?.name.length > 20 ? '...' : '' }} </h4>
                      <!-- <div class="doc-degree"> MBBS, MCPS, MSc (Immunology)</div> -->
                      <div class="doc-rating">
                        <div *ngIf="pharmacy.rating" class="doc-rating-icons">
                          <i *ngFor='let in of counter( pharmacy.rating) ;let i = index' class="fa fa-star"
                            aria-hidden="true"></i>
                          <i class="fa fa-star-o" *ngFor='let in of counter(5- pharmacy.rating) ;let i = index'
                            aria-hidden="true"></i>
                        </div>
                        <div *ngIf="pharmacy.rating==null || pharmacy.rating==0" class="doc-rating-icons">

                          <i class="fa fa-star-o" *ngFor='let in of counter(5) ;let i = index' aria-hidden="true"></i>


                        </div>
                        <span> {{ !pharmacy.rating ? 0 : pharmacy.rating }} | {{ pharmacy.review.length }}
                          Reviews </span>
                      </div>
                      <p class="hos-box-bmt-info">
                        <span> Registered Pharmacy <img style="width:25px;height:25px;display:inline;"
                            src="assets/images/bluetick.png">
                        </span>
                      </p>
                      <div class="doc-adres">
                        <p><i class="fa fa-map-marker" aria-hidden="true"></i> {{ pharmacy.address.slice(0, 30) }}
                          {{ pharmacy.address.length > 30 ? '...' : '' }}
                        </p>
                        <!-- <p><i class="fa fa-calendar-check-o" aria-hidden="true"></i> Mon, Tue, Wed, Thu </p> -->
                      </div>
                      <div class="doc-btn-main">
                        <a [routerLink]="['/pharmacy/detail/'+pharmacy._id]" class="btn-style btn-style-border"> Book
                          Now </a>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- </ul> -->
              </ngx-slick-carousel>

              <div class="home-facilites-btm-btn text-right">
                <a [routerLink]="['/pharmacy/list']" class="btn-arrow"> View All <i class="fa fa-long-arrow-right"
                    aria-hidden="true"></i> </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<!-- End of home-facilities  -->


<section class="read-top-blog padd-row">
  <div class="read-top-blog-main">
    <div class="container">
      <div class="d-md-flex">
        <div class="read-top-blog-cnt-box">
          <div class="read-top-blog-cnt">
            <h2> <span> Yoga </span> for Life </h2>
            <p> Top Blogs from Yoga Experts to keep you informed about good health practices </p>
            <div class="main-btn">
              <a [routerLink]="['/articles']" class="btn-style"> See all Blogs </a>
            </div>
          </div>
        </div>
        <div class="read-top-blog-img-main">
          <div *ngFor="let hospitalBlog of homePageData?.listHospitalBlogs?.slice(0,2)" class="read-top-blog-imgas">
            <a [routerLink]="['/blog-detail/'+hospitalBlog?.uniquekey]">
              <img [src]="hospitalBlog.image" alt="image">
              <div class="text-width">{{ hospitalBlog?.title }}</div>
            </a>

            <!-- <img src="assets/images/read-blog-img-2.jpg" alt="image"> -->
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- <div class="read-btm-blog">
    <div class="container">
      <div class="read-btm-blog-main">
        <div class="read-btm-blog-img">
          <img [src]="homePageData?.listHospitals?.listAllData[0]?.coverPhoto" alt="image">
        </div>
        <div class="read-btm-blog-box">
          <div class="main-heading">
            <h2> {{ homePageData?.listHospitals?.listAllData[0]?.name }}</h2>
          </div>
          <div class="read-btm-blog-box-cnt">
            <p> {{ homePageData?.listHospitals?.listAllData[0]?.description?.slice(0,300) }}{{ homePageData?.listHospitals?.listAllData[0]?.description?.length>300 ? '...' : '' }}</p>
            <a [routerLink]="['/hospitals/detail/'+homePageData?.listHospitals?.listAllData[0]?._id]" class="btn-arrow"> View Hospital <i class="fa fa-long-arrow-right" aria-hidden="true"></i> </a>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</section>
<!-- End ofread-top-blog -->

<section class="our-blog padd-row">
  <div class="container">
    <div class="main-heading text-center">
      <h2> Health Articles </h2>
    </div>
    <div class="our-blog-main">
      <div class="row">
        <div *ngFor="let blog of homePageData?.listDoctorBlogs" class="col-md-6 col-lg-3">
          <a [routerLink]="['/blog-detail/'+blog?.uniquekey]" class="our-blog-box">
            <div class="blog-box-img">
              <img [src]="blog.image" alt="blog-box">
            </div>
            <div class="blog-box-cnt">
              <h4> {{ blog.title }} </h4>
              <!-- <p [innerHTML]="blog.text.slice(0,25)"></p> -->
            </div>
          </a>
        </div>

      </div>
    </div>
  </div>
</section>
<!-- End our-blog -->

<!-- <section class="our-customers padd-row">
  <div class="main-heading text-center">
    <h2> Our Happy Customers </h2>
  </div>
  <div class="our-customers-main">
    <ngx-slick-carousel class="carousel"
                        #slickModal4="slick-carousel"
                        [config]="slideConfigCustomers"
    >


      <div ngxSlickItem class="slider">

        <div class="our-customers-box">
          <div class="our-customers-box-img">
            <img src="assets/images/testi-img-1.jpg" alt="image">
          </div>
          <div class="our-customers-box-cnt">
            <h4> David Smith <span> USA </span></h4>
            <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Printing and typesetting
              industry Lorem Ipsum is simply dummy text of the . Lorem Ipsum is simply dummy text of the printing. And
              typesetting industry Lorem Ipsum is simply dummy text of the printing.
          </div>
        </div>
      </div>
      <div ngxSlickItem class="slider">
        <div class="our-customers-box">
          <div class="our-customers-box-img">
            <img src="assets/images/testi-img-2.jpg" alt="image">
          </div>
          <div class="our-customers-box-cnt">
            <h4> John Walker <span> Canada </span></h4>
            <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Printing and typesetting
              industry Lorem Ipsum is simply dummy text of the . Lorem Ipsum is simply dummy text of the printing. And
              typesetting industry Lorem Ipsum is simply dummy text of the printing.
          </div>
        </div>
      </div>
      <div ngxSlickItem class="slider">
        <div class="our-customers-box">
          <div class="our-customers-box-img">
            <img src="assets/images/testi-img-1.jpg" alt="image">
          </div>
          <div class="our-customers-box-cnt">
            <h4> David Smith <span> USA </span></h4>
            <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Printing and typesetting
              industry Lorem Ipsum is simply dummy text of the . Lorem Ipsum is simply dummy text of the printing. And
              typesetting industry Lorem Ipsum is simply dummy text of the printing.
          </div>
        </div>
      </div>
      <div ngxSlickItem class="slider">
        <div class="our-customers-box">
          <div class="our-customers-box-img">
            <img src="assets/images/testi-img-2.jpg" alt="image">
          </div>
          <div class="our-customers-box-cnt">
            <h4> John Walker <span> Canada </span></h4>
            <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Printing and typesetting
              industry Lorem Ipsum is simply dummy text of the . Lorem Ipsum is simply dummy text of the printing. And
              typesetting industry Lorem Ipsum is simply dummy text of the printing.
          </div>
        </div>
      </div>

    </ngx-slick-carousel>
  </div>
</section> -->
<!-- End our-blog -->

<input type="hidden" id="emergency_trigger" data-toggle="modal" data-target="#emergency-book">
<!-- The Modal -->
<div class="modal fade" id="emergency-book">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">
        <div class="sign-up-form emgergency-form">
          <h2 class="text-center"><span> Book a Ambulance </span></h2>
          <form action="ambulance-tracking.html">
            <div class="row">

              <div class="col-md-12">
                <label> Enter Your Location </label>
                <div class="form-group-main">
                  <input type="text" ngx-google-places-autocomplete #placesRef1="ngx-places"
                    (onAddressChange)="handleAddressChange($event)" #place class="form-control" name="locationAddress"
                    [options]='options' [(ngModel)]="bookObject.address" placeholder="Chandigarh...">
                  <img src="assets/images/location.png" alt="image">
                </div>
              </div>

              <div class="col-md-12">
                <div id="mapLocation"></div>
                <div class="centerMarker"></div>
              </div>

              <div class="col-md-12">
                <label> Enter Your Name </label>
                <div class="form-group-main">
                  <input type="text" class="form-control" name="userName" [(ngModel)]="bookObject.name"
                    placeholder="Enter Name...">
                  <img src="assets/images/form-user.png" alt="image">
                </div>
              </div>
              <div class="col-md-12">
                <label> Enter Phone Number </label>
                <div class="form-group-main">
                  <input type="number" class="form-control" name="phoneNobook" [(ngModel)]="bookObject.phoneNo"
                    placeholder="Phone No...">
                  <img src="assets/images/phone.png" alt="image">
                  <p class="error" [ngStyle]="{ 'display': errorOtpBooking_user ? 'block' : 'none', 'color':'red' }">
                    {{ errorOtpUserBookingMessage }}
                  </p>
                </div>
              </div>
              <div class="col-md-12">
                <input *ngIf="isLoggedIn" type="submit" value="Book Now" (click)="bookAmbulance(true)"
                  class="btn-style">
                <input *ngIf="!isLoggedIn" type="submit" value="Book Now" (click)="bookAmbulance_without_login()"
                  class="btn-style">
                <a style="display:none;" routerLink="" data-toggle="modal" id="booking_otp_trigger"
                  data-target="#booking_otp"></a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="booking_otp">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">
        <div class="sign-up-form login-form">
          <!-- <h2 class="text-center"> <span>Enter Verification Code </span> to Book Ambulance </h2> -->
          <div [ngStyle]="{'display': !!showbookingotp_user_login ? 'block' : 'none' }" id="booking-otp">
            <i class="fa fa-arrow-left" (click)="back()" aria-hidden="true"></i>
            <h2 class="text-center"><span> Verification Code </span></h2>
            <form action="user.html">
              <div class="row">
                <div class="col-md-12">
                  <div class="login-mob-img">
                    <img src="assets/images/login-mob-img-otp.jpg" alt="image">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="login-otp-recived">
                    <h5> Otp has been send to <span> {{ bookObject.phoneNo }} </span></h5>
                    <div class="otp-input-group">

                      <!-- <input *ngFor="let obj of otpValObjUser" type="text" maxlength="1" (keypress)="numberOnly($event,obj.arg)"  [name]="obj.name" [(ngModel)]="obj.model" [id]="obj.id" class="form-control"> -->
                      <input type="text" maxlength="1" (keypress)="numberOnly($event,'next_booking')" name="otp2"
                        [(ngModel)]="otpValObj1_booking" class="form-control">
                      <input type="text" maxlength="1" (keypress)="numberOnly($event,'next1_booking')" id="next_booking"
                        name="otp2" [(ngModel)]="otpValObj2_booking" class="form-control">
                      <input type="text" maxlength="1" (keypress)="numberOnly($event,'next2_booking')"
                        id="next1_booking" name="otp3" [(ngModel)]="otpValObj3_booking" class="form-control">
                      <input type="text" maxlength="1" (keypress)="numberOnly($event,null)" id="next2_booking"
                        name="otp4" [(ngModel)]="otpValObj4_booking" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <input type="submit" value="Book Ambulance" (click)="checkOtpfuncUserBookingLogin()"
                    class="btn-style">
                  <div *ngIf="verifyOtpError_Booking" style="color:red">Otp does not match</div>
                  <div class="resend-otp">
                    <a [routerLink]="['']" (click)="resendOtp()"> Resend OTP </a>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div id="booking-otp-pass" [ngStyle]="{'display': showbooking_pass_user ? 'block' : 'none' }">
            <i class="fa fa-arrow-left" (click)="back()" aria-hidden="true"></i>
            <h2 class="text-center"><span> Enter Password </span></h2>
            <form>
              <div class="row">

                <div class="col-md-12">
                  <div class="login-otp-recived">
                    <input [type]="showEyeUserBooking ? 'password' : 'text'" name="pass_user"
                      [(ngModel)]="Pass_userBooking" class="form-control">
                    <span [class]="showEyeUserBooking ? 'fa fa-fw fa-eye' : 'fa fa-fw fa-eye-slash'"
                      (click)="showEyeUserBooking=!showEyeUserBooking"></span>

                  </div>
                </div>
                <div class="col-md-12">
                  <input type="submit" value="Login & Book" (click)="checkPassfunc_userBooking()" class="btn-style">
                  <div *ngIf="verifyPassError_userBooking" style="color:red">Password does not match</div>
                  <div class="resend-otp">
                    <a [routerLink]="null" (click)="forgotPassUser()"> Forgot Password? </a>
                  </div>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="advanced_search_popup">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">
        <div class="modal-header">
          <h5 class="modal-title">Advanced Search</h5>

          <div class="header-btm-search">
            <ul>
              <li>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customCheck" name="example1">
                  <label class="custom-control-label" for="customCheck"> By Location </label>
                </div>
              </li>
              <li>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customCheck1" name="example2">
                  <label class="custom-control-label" for="customCheck1"> By Rating </label>
                </div>
              </li>
            </ul>
          </div>


          <button class="btn-style"> Submit</button>
        </div>

        <div class="header-btm-sort-results home-header-btm-sort-results">
          <div class="container">
            <ul class="clearfix">
              <li>
                <div class="header-btm-sort-box">
                  <h5> Availability </h5>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-1" name="example1">
                    <label class="custom-control-label" for="cutm-check-1"> Today </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-2" name="example1">
                    <label class="custom-control-label" for="cutm-check-2"> This Week </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-3" name="example1">
                    <label class="custom-control-label" for="cutm-check-3"> Next Week </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-4" name="example1">
                    <label class="custom-control-label" for="cutm-check-4"> Next Month </label>
                  </div>
                </div>
              </li>
              <li>
                <div class="header-btm-sort-box">
                  <h5> Consultation Days </h5>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-5" name="example1">
                    <label class="custom-control-label" for="cutm-check-5"> Monday </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-6" name="example1">
                    <label class="custom-control-label" for="cutm-check-6"> Tuesday </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-7" name="example1">
                    <label class="custom-control-label" for="cutm-check-7"> Wednesday </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-8" name="example1">
                    <label class="custom-control-label" for="cutm-check-8"> Thursday </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-9" name="example1">
                    <label class="custom-control-label" for="cutm-check-9"> Friday </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-10" name="example1">
                    <label class="custom-control-label" for="cutm-check-10"> Saturday </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-11" name="example1">
                    <label class="custom-control-label" for="cutm-check-11"> Sunday </label>
                  </div>
                </div>
              </li>
              <li>
                <div class="header-btm-sort-box">
                  <h5> Timings </h5>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-12" name="example1">
                    <label class="custom-control-label" for="cutm-check-12"> Morning </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-13" name="example1">
                    <label class="custom-control-label" for="cutm-check-12"> Afternoon </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-14" name="example1">
                    <label class="custom-control-label" for="cutm-check-14"> Evening </label>
                  </div>
                </div>
              </li>
              <li>
                <div class="header-btm-sort-box">
                  <h5> Language Spoken </h5>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-15" name="example1">
                    <label class="custom-control-label" for="cutm-check-15"> English </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-16" name="example1">
                    <label class="custom-control-label" for="cutm-check-16"> Hindi </label>
                  </div>
                </div>
              </li>
              <li>
                <div class="header-btm-sort-box">
                  <h5> Gender </h5>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-17" name="example1">
                    <label class="custom-control-label" for="cutm-check-17"> Male </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-18" name="example1">
                    <label class="custom-control-label" for="cutm-check-18"> Female </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="cutm-check-19" name="example1">
                    <label class="custom-control-label" for="cutm-check-19"> Others </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>


      </div>


    </div>
  </div>
</div>


<!-- <input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal"> -->

<!-- The Modal -->
<div class="modal fade" id="orderImagesModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Banners</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body text-center">
        <carousel>
          <slide (click)="gotoDetail(banner)" *ngFor="let banner of banners">
            <img [src]="banner.image" alt="first slide" style="display: block; width: 100%;">
          </slide>

        </carousel>
        <!-- <slideshow
            (onClick)="testEvent($event)"
            #slideshow
            [minHeight]="'525px'"
            [showArrows]="imageUrlArray.length>1 ? true: false"
            [imageUrls]="imageUrlArray"></slideshow> -->

        <!-- <button class="btn btn-primary" style="margin-top: 20px;"
 data-toggle="modal" data-target="#orderImagesModal">OK</button> -->

      </div>
    </div>
  </div>
</div>